/**
 * Created by Mark on 18/12/2016.
 */

import ApplicationServices from './base-service.js';
import Constants from '../constants.js';
import Action    from '../application-actions.js';

class  ClassesService {


    doesStudentsExist(students , classID){

        return ApplicationServices.call(Constants.DOES_STUDENT_EXIST , {classID:classID , students:students}).then(function(response){
            return response
        });
    }

    addStudents(students , classID)
    {
        return ApplicationServices.call(Constants.ADD_STUDENTS , {classID:classID , students:students}).then(function(response){
            return response
        });
    }

    updateHints(classID , hints){
        return ApplicationServices.call(Constants.UPDATE_CLASS_HINTS , {classID:classID , hints:hints}).then(function(response){
            return response
        });
    }

    updateLanguages(languages , ClassID){

        return ApplicationServices.call(Constants.GET_CLASSES_LANGUAGES , {classID:ClassID , selectedlanguages:languages}).then(function(response){
           return response
        });
    }

    getTeachers(classUid){
        return ApplicationServices.call(Constants.GET_TEACHERS , {classUid:classUid , isList:1}).then(function(response){
            Action.update(Constants.GET_TEACHERS , response.list);
        });
    }

    getStudents(classUid){
        return ApplicationServices.call(Constants.GET_STUDENTS , {classUid:classUid , isList:1, cefr:true}).then(function(response){
            Action.update(Constants.GET_STUDENTS , response.list);
        });
    }

    getStudentsAll(){
        return ApplicationServices.call(Constants.GET_STUDENTS , {isList:1, filterTestExam:1, cefr:true}).then(function(response){
            Action.update(Constants.GET_STUDENTS , response.list);
            return response.list;
        });
    }

    getLocale(){
        return (navigator.languages && navigator.languages[0]) || navigator.language || navigator.userLanguage;
    };

    create(className , students , allLanguages , selectedlanguages , shareTeachers){
        return ApplicationServices.call(Constants.CREATE_CLASS , {className:className , students:students , 
                    allLanguages:allLanguages , selectedlanguages:selectedlanguages , shareTeachers:shareTeachers}).then(function(response){
            this.getMine();
            //REsponse to update
            return response['class_uid'];
        }.bind(this));
    }

    delete(classID){
        return ApplicationServices.call(Constants.DELETE_CLASS , {classID:classID }).then(function(response){
            Action.update(Constants.DELETE_CLASS , response);
            //   return response.translations
        });
    }

    deleteStudent(studentUid){
        return ApplicationServices.call(Constants.DELETE_STUDENT , {studentUid:studentUid}).then(function(response){
            Action.update(Constants.DELETE_STUDENT , response);
        });
    }

    get(classID)
    {
        return ApplicationServices.call(Constants.GET_CLASS , {classID:classID}).then(function(response){
               Action.update(Constants.ON_CLASS_FETCH , response.myClass);
        });
    }

    getMine(){
        return ApplicationServices.call(Constants.GET_MY_CLASSES , {}).then(function(response){
            Action.update(Constants.GET_MY_CLASSES , response.classes);
        });
    }

    list(){
        return ApplicationServices.call(Constants.GET_CLASSES_LIST , {}).then(function(response){
            Action.update(Constants.GET_CLASSES_LIST , response.classes);
        });
    }

    getClass(classUid){
        return ApplicationServices.call(Constants.GET_CLASS_DATA , {classUid:classUid}).then(function(response){
            Action.update(Constants.GET_CLASS_DATA , response.class);
        });
    }

    updateName(className , classID){
        return ApplicationServices.call(Constants.UPDATE_CLASS_NAME , {className:className , classID:classID}).then(function(response){
            return response['isValid'];
        });
    }

    updateStudentName(studentName , studentUid){
        return ApplicationServices.call(Constants.UPDATE_STUDENT_NAME , {studentName:studentName , studentUid:studentUid}).then(function(response){
            return response['isValid'];
        });
    }

    updateStudentLanguage(ietf , studentUid){
        return ApplicationServices.call(Constants.UPDATE_STUDENT_LANGUAGE , {ietf:ietf , studentUid:studentUid}).then(function(response){
            return response['isValid'];
        });
    }

    updateStudentClasses(classes , studentUid){
        return ApplicationServices.call(Constants.UPDATE_STUDENT_CLASSES , {classes:classes , studentUid:studentUid}).then(function(response){
            return response['isValid'];
        });
    }

    updateTeachers(staff , classID){
        return ApplicationServices.call(Constants.UPDATE_CLASS_STAFF , {staff:staff , classUid:classID}).then(function(response){
            return response['isValid'];
        });
    }

    updateAddStudents(students , classID){
        return ApplicationServices.call(Constants.UPDATE_CLASS_STUDENTS , {students:students , classUid:classID}).then(function(response){
            return response['isValid'];
        });
    }

    doesNameExist(className){
        return ApplicationServices.call(Constants.VALIDATE_CLASS_NAME_CALL , {className:className }).then(function(response){
            return response['isValid'];
        });
    }
    
    students(uid){
        return ApplicationServices.call(Constants.GET_CLASSES_STUDENTS_LIST , {class_uid:uid}).then(function(response){
            Action.update(Constants.GET_CLASSES_STUDENTS_LIST , response.students);
        });
    }

    student(uid){
        return ApplicationServices.call(Constants.GET_CLASSES_STUDENTS_LIST , {student_uid:uid}).then(function(response){
            Action.update(Constants.GET_CLASSES_STUDENTS_LIST , response.students);
        });
    }

    allStudents(){
        return ApplicationServices.call(Constants.GET_ALL_STUDENTS_LIST , {}).then(function(response){
            Action.update(Constants.GET_ALL_STUDENTS_LIST , response.students);
        });
    }

    getClassActivity(classID, from, to, languageValue){
        return ApplicationServices.call(Constants.GET_CLASS_ACTIVITY , {languageID:languageValue , from:from , to:to , classID:classID}).then(function(response){
            Action.update(Constants.GET_CLASS_ACTIVITY , response.activity);
        });
    }

    getStudentActivity(studentUid, from, to, languageValue){
        return ApplicationServices.call(Constants.GET_STUDENT_ACTIVITY , {languageID:languageValue , from:from , to:to , studentID:studentUid}).then(function(response){
            Action.update(Constants.GET_STUDENT_ACTIVITY , response.activity);
        });
    }

    updateFav(toggle , homeworkUID){
        return ApplicationServices.call(Constants.UPDATE_FAV , {favourite:toggle , homeworkUID:homeworkUID });
    }

    updateFavLibrary(toggle , homeworkUID, curriculumUID){
        return ApplicationServices.call(Constants.UPDATE_FAV_LIBRARY , {favourite:toggle , homeworkUID:homeworkUID, curriculumUID:curriculumUID });
    }

    getClassFavourite(classUID){
        return ApplicationServices.call(Constants.GET_CLASS_FAV_ASSIGNMENTS , {class_uid:classUID}).then(function(response){
            Action.update(Constants.GET_CLASS_FAV_ASSIGNMENTS , response.assignments);
        })
    }

    getStudentActivity(studentID, from, to, languageValue){
        return ApplicationServices.call(Constants.GET_STUDENT_ACTIVITY , {languageID:languageValue , from:from , to:to , studentID:studentID}).then(function(response){
            Action.update(Constants.GET_STUDENT_ACTIVITY , response.activity);
        });
    }

    getStudentActivityNew(studentID, from, to, languageValue){
        return ApplicationServices.call(Constants.GET_STUDENT_ACTIVITY_NEW , {languageID:languageValue , from:from , to:to , studentUID:studentID}).then(function(response){
            Action.update(Constants.GET_STUDENT_ACTIVITY_NEW , response.activity);
        });
    }

    getProgress(classUID){
        return ApplicationServices.call(Constants.GET_CLASS_PROGRESS , {classUID:classUID}).then(function(response){
            Action.update(Constants.GET_CLASS_PROGRESS , response);
        });
    }

    getVocabularyCompleted(classUID, studentUid, packageUID , languageID , screenUID){
        return ApplicationServices.call(Constants.GET_CLASS_VOCABULARY_COMPLETED , {screenUid:screenUID , packageUID:packageUID , 
                    language:languageID , classUID:classUID, studentUid:studentUid}).then(function(response){
            Action.update(Constants.GET_CLASS_VOCABULARY_COMPLETED , response.modules);
        });
    }

    getVocabularyCompletedStudents(classUID, studentUid, curriculumUid , languageID, disableCallback){
        return ApplicationServices.call(Constants.GET_CLASS_STUDENT_VOCABULARY_COMPLETED , 
            {classUID:classUID , curriculumUid:curriculumUid , language:languageID, studentUid:studentUid}).then(function(response){
                if (disableCallback == true) {
                    return response.students
                } else {
                    Action.update(Constants.GET_CLASS_STUDENT_VOCABULARY_COMPLETED , response.students);
                }
        });
    }

    getMyContentCompletedStudents(classUID, studentUid, curriculumUid , languageID, disableCallback){
        return ApplicationServices.call(Constants.GET_CLASS_STUDENT_MYCONTENT_COMPLETED , 
            {classUID:classUID , curriculumUid:curriculumUid , language:languageID, studentUid:studentUid}).then(function(response){
                if (disableCallback == true) {
                    return response.students
                } else {
                    Action.update(Constants.GET_CLASS_STUDENT_MYCONTENT_COMPLETED , response.students);
                }
        });
    }

    getVerbCompletedStudents(classUID, studentUid, curriculumUid , languageID){
        return ApplicationServices.call(Constants.GET_CLASS_STUDENT_VERB_COMPLETED , 
            {classUID:classUID , curriculumUid:curriculumUid , language:languageID, studentUid:studentUid}).then(function(response){
            Action.update(Constants.GET_CLASS_STUDENT_VERB_COMPLETED , response.students);
        });
    }

    getGrammarCompletedStudents(classUID, studentUid, curriculumUid, languageUid, screenUid){
        return ApplicationServices.call(Constants.GET_CLASS_STUDENT_GRAMMAR_COMPLETED , 
            {classUID:classUID , curriculumUid:curriculumUid , language:languageUid, screenUid:screenUid, studentUid:studentUid}).then(function(response){
            Action.update(Constants.GET_CLASS_STUDENT_GRAMMAR_COMPLETED , response.students);
        });
    }

    getSentenceCompletedStudents(classUID, studentUid, curriculumUid, languageUid, screenUid){
        return ApplicationServices.call(Constants.GET_CLASS_STUDENT_SENTENCE_COMPLETED , 
            {classUID:classUID , curriculumUid:curriculumUid , language:languageUid, screenUid:screenUid, studentUid:studentUid}).then(function(response){
            Action.update(Constants.GET_CLASS_STUDENT_SENTENCE_COMPLETED , response.students);
        });
    }

    getExamCompletedStudents(classUID, studentUid, curriculumUid , languageID , screenUID){
        return ApplicationServices.call(Constants.GET_CLASS_STUDENT_EXAM_COMPLETED , 
            {classUID:classUID , curriculumUid:curriculumUid , screenUid:screenUID, language:languageID, studentUid:studentUid}).then(function(response){
            Action.update(Constants.GET_CLASS_STUDENT_EXAM_COMPLETED , response.students);
        });
    }

    getExamComplete(classUID, studentUid, packageUID , languageID , screenUID){
        return ApplicationServices.call(Constants.GET_CLASS_EXAM_COMPLETED , {screenUid:screenUID , packageUID:packageUID , language:languageID,
                    classUID:classUID, studentUid:studentUid}).then(function(response){
            Action.update(Constants.GET_CLASS_EXAM_COMPLETED , response.modules);
        });
    }

    getExamQuestion(classUID, packageUID, languageID, examUid){
        return ApplicationServices.call(Constants.GET_CLASS_EXAM_QUESTION, {examUid:examUid , packageUID:packageUID , language:languageID , classUID:classUID}).then(function(response){
            Action.update(Constants.GET_CLASS_EXAM_QUESTION , response.modules);
        });
    }

    getPronunciationCompleted(classUID  , packageUID , languageID , screenUID){
        return ApplicationServices.call(Constants.GET_CLASS_PRONUNCIATION_COMPLETED , {screenUid:screenUID , packageUID:packageUID , language:languageID , classUID:classUID}).then(function(response){
            Action.update(Constants.GET_CLASS_PRONUNCIATION_COMPLETED , response.modules);
        });
    }

    getGrammerComplete(classUID, packageUID, languageID, screenUID){
        return ApplicationServices.call(Constants.GET_CLASS_GRAMMER_COMPLETED , {
                    screenUid:screenUID , packageUID:packageUID , moduleLimitations:{ietf:languageID},
                    language:languageID , classUID:classUID}).then(function(response){
            Action.update(Constants.GET_CLASS_GRAMMER_COMPLETED , response.modules);
        });
    }

    getVerbComplete(classUID, languageID){
        return ApplicationServices.call(Constants.GET_CLASS_VERB_COMPLETED , {
                    classUID:classUID , toIetf:languageID , classUID:classUID}).then(function(response){
            Action.update(Constants.GET_CLASS_VERB_COMPLETED , response.verbs);
        });
    }

    getSentenceComplete(classUID  , packageUID , languageID , screenUID){
        return ApplicationServices.call(Constants.GET_CLASS_GRAMMER_COMPLETED , {screenUid:screenUID , packageUID:packageUID , language:languageID , classUID:classUID}).then(function(response){
            Action.update(Constants.GET_CLASS_SENTENCE_COMPLETED , response.modules);
        });
    }

    getProgressStudent(studentUID){
        return ApplicationServices.call(Constants.GET_STUDENT_PROGRESS , {studentUID:studentUID}).then(function(response){
            Action.update(Constants.GET_STUDENT_PROGRESS , response);
        });
    }

    getVocabularyCompletedStudent(studentUID  , packageUID , languageID , screenUID){
        return ApplicationServices.call(Constants.GET_STUDENT_VOCABULARY_COMPLETED , {screenUid:screenUID , packageUID:packageUID , language:languageID , studentUID:studentUID}).then(function(response){
            Action.update(Constants.GET_STUDENT_VOCABULARY_COMPLETED , response.modules);
        });
    }

    getExamCompleteStudent(studentUID  , packageUID , languageID , screenUID){
        return ApplicationServices.call(Constants.GET_STUDENT_EXAM_COMPLETED , 
            {screenUid:screenUID , packageUID:packageUID , language:languageID , studentUID:studentUID}).then(function(response){
            Action.update(Constants.GET_STUDENT_EXAM_COMPLETED , response.modules);
        });
    }

    getPronunciationCompletedStudent(studentUID  , packageUID , languageID , screenUID){
        return ApplicationServices.call(Constants.GET_STUDENT_PRONUNCIATION_COMPLETED , 
            {screenUid:screenUID , packageUID:packageUID , language:languageID , studentUID:studentUID}).then(function(response){
            Action.update(Constants.GET_STUDENT_PRONUNCIATION_COMPLETED , response.modules);
        });
    }

    getGrammerCompleteStudent(studentUID  , packageUID , languageID , screenUID){
        return ApplicationServices.call(Constants.GET_STUDENT_GRAMMER_COMPLETED , 
            {screenUid:screenUID , packageUID:packageUID , language:languageID , studentUID:studentUID}).then(function(response){
            Action.update(Constants.GET_STUDENT_GRAMMER_COMPLETED , response.modules);
        });
    }

    getClassesAssignments(classUID){
        return ApplicationServices.call(Constants.GET_CLASS_ASSIGNMENTS , {class_uid:classUID}).then(function(response){
                Action.update(Constants.GET_CLASS_ASSIGNMENTS , response);
        });
    }

    getStudentAssignments(studentUid){
        return ApplicationServices.call(Constants.GET_STUDENT_ASSIGNMENTS , {studentUid:studentUid}).then(function(response){
                Action.update(Constants.GET_STUDENT_ASSIGNMENTS , response.homework);
        });
    }

    getClassesArchivedAssignments(classUID){
        return ApplicationServices.call(Constants.GET_CLASS_ARCHIVED_ASSIGNMENTS , {class_uid:classUID}).then(function(response){
            Action.update(Constants.GET_CLASS_ARCHIVED_ASSIGNMENTS , response.assignments);
        });
    }

    removeUser(classID , userID) {
        return ApplicationServices.call(Constants.REMOVE_STUDENT , {classID:classID  , userID:userID });
    }

    addLicenses(numberOfStudents, teacherName, teacherEmail) {
        return ApplicationServices.call(Constants.ADD_LICENSES , {numberOfStudents:numberOfStudents  , teacherName:teacherName, teacherEmail:teacherEmail});
    }
}

export default new ClassesService();